import React, { useState, useEffect } from 'react';
import { LoginCard, PageContainer,RegistrationForm, StyledInput,FieldTitleNew, Button, Footer, CheckboxContainer, CheckboxGrid, BottomCard, CheckBoxContainer, /*CheckboxCard,*/ /*ConfirmationText,*/ InputWrapper, EyeIconWrapper,CustomToggle, CustomToggleWrapper, ErrorText, ButtonContainer, BorderButton, PillarCard } from './style.js';
import { ImageUrl, TimeZone } from '../../utils/constants';
import {Divider} from '../../components/Manager/styles';
import { Container } from './style';
import { BackArrowFeed, BirthdateCalendarIcon, DropIcon, hidePassword, PasswordEyeIcon } from '../../utils/icons';
import { fetchApi, isValidContactNumber } from '../../utils/methods';
import { toast, ToastContainer } from 'react-toastify';
import { ResendOtpForComapny, GetWellnessInterests, GetWellbeingPillars, GetUserDetailsByToken, VerifyUserEmail, SendRegistrationOtp, VerifyRegistrationOtp, RegisterUser, VerifyCompanyName, SendRegistrationOtpWithCompany } from '../../redux/constants/apiConstants';
import { CustomDropdownItemV1, CustomMenuV1, DropdownWrapper } from '../../components/TopBarV3';
import { Dropdown } from 'react-bootstrap';
import { IconContainer, StyledImage } from '../../components/TopBarV3/style';
import { withTranslation } from 'react-i18next';
import { DateCalendarWrapper } from '../../components/ChallengeDetailsV2/StartChallengePopUp/styles';
import { DateCard } from '../../components/ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import dayjs from 'dayjs';
import { RadioButton, RadioButtonWrapper } from '../../components/RecogntionAdmin/styles';
import { DropdownContent, InterestCard, WellnessCardNew } from '../../components/UserProfile/styles';
import CustomCalendar from '../../components/common/DateRangePicker/CustomCalendar.js';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min.js';
import PropTypes from 'prop-types';
import RunningLoader from '../../components/common/Loaders/runningLoader.js';
import Spinner from '../../components/common/Spinner/index.js';
import { connect } from 'react-redux';
import { authenticatedUser, fetchLanguages } from '../../redux/actions/index.js';
import i18n from '../../Lang/i18n.js';
import { getLanguages } from '../../../mockData.js';
import { t } from 'i18next';

const WellnessData = [
  "Individual Sports",
  "Water Sports",
  "Ball Sports",
  "Wheel Sports",
  "Winter Sports",
  "Combat Sports",
  "Resistance Training",
  "Other"
];

function Registration({history,setAuthenticatedUser}) {


  const getInitialLang = () => {
    try {
      return localStorage.getItem("lang") || "en";
    } catch (e) {
      return "en";
    }
  };
  
  const [lang, setLang] = useState(getInitialLang);
  
  // const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const[screen, setScreen] = useState("get-started");
  const[otp, setOtp] = useState('');
  //   const[registrationRes, setRegistrationRes] = useState(null);
  const[registrationToken, /*setRegistrationToken*/] = useState('');
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [resend, setResend] = useState(false);
  const [wellbeingPillars, setWellbeingPillars] = useState([]);
  const[resendbutton, setResendbutton] = useState(true);
  const [otpError, setOtpError] = useState(false);
  //   const [companyPopup, setCompanyPopup] = useState(false);
  const [selectedWellbeingPillars, setSelectedWellbeingPillars] = useState([]);
  const[state, setState] = useState({
    firstName:"",
    lastName:"",
    email:"", 
    companyName:'',
    password:'',
    cpassword:'',
    birthDate:'',
    privacyPolicy:false,
    contactNumber:null,
    user_type:0
  });

  //   const [showPassword, setShowPassword] = useState(false);
  const [wellnessInterests, setWellnessInterests] = useState([]);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [interestData, /*steInterestData*/]= useState(true);
  const [datePopup, setDatePopup] = useState(false);
  const [token, setToken] = useState(null);
  const [isFromMagicLink,setIsFromMagicLink] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [loader, setLoader] = useState(null);
  const [showPassword, setShowPassword]= useState(false);
  const [showCPassword, setShowCPassword]= useState(false);
  const [contactError,setContactError]= useState(false);
  const [passwordError,setPasswordError]= useState(false);
  const [emailError,setEmailError]= useState(false);

  const[companyName, setCompanyName]= useState('');
  const[companyPassword, setCompanyPassword]= useState('');
  const [showCompanyPassword, setShowCompanyPassword]= useState(false);
  const [registrationWithCompany, setRegstrationWithCompany] = useState(false);



  useEffect(()=>{
    let lang = localStorage.getItem("lang") || "en";
    takeLanguageData(lang);
  },[]);

  useEffect(() => {
    const queryParams = new window.URLSearchParams(history.location.search);
    const tokenFromURL = queryParams.get("token");

    if (tokenFromURL) {
      setToken(tokenFromURL);
      setIsFromMagicLink(true);
      FetchUserDetails(tokenFromURL);
      setScreen('get-started');
      setRegstrationWithCompany(false)
    } else {
      setIsFromMagicLink(false);
      setScreen('verify-email');
    }
  }, [history.location.search]);

  // useEffect(() => {
  //   if(resend){
  //     if (secondsLeft === 0) {
  //       return;
  //     }
  
  //     const timerId = window.setInterval(() => {
  //       setSecondsLeft((prevSeconds) => prevSeconds - 1);
  //     }, 1000);
  //     return () => window.clearInterval(timerId);
  //   }
   
  // }, [secondsLeft]);


  useEffect(() => {
    if (resend) {
      if (secondsLeft === 0) {
        return () => {}; // always return a function
      }
  
      const timerId = window.setInterval(() => {
        setSecondsLeft((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => window.clearInterval(timerId);
    }
  
    return () => {}; //return empty function when resend is false

  }, [secondsLeft]);

  // const isNameValid = (name) => {
  //   const regex = /^[A-Za-z\s]+$/;
  //   return name?.trim()?.length >= 1 && regex.test(name);
  // };
  
  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const takeLanguageData = (lang) => {
    // const { putUpdateLanguage } = this.props;
    // let obj = {
    //   user_language: lang === 'en' ? "english" : lang === 'es' ? 'Spanish' : lang === 'pt' ? 'Portuguese': 'French'
    // };
    const langCode = lang === 'en' ? 1 : lang === 'es' ? 2 : lang === 'fr' ? 3 : lang === 'pt' ? 4: 1;
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    setLang(lang);
    getAllWellbeingPillars(langCode);
    FetchWellnessInterests(langCode);
    // putUpdateLanguage(obj);
  };


  // useEffect(() => {
  //   if (!resend || secondsLeft === 0) return;
  
  //   const timerId = window.setInterval(() => {
  //     setSecondsLeft((prevSeconds) => prevSeconds - 1);
  //   }, 1000);
  
  //   // Cleanup
  //   return () => window.clearInterval(timerId);
  // }, [resend, secondsLeft]);

  const FetchUserDetails = async(token)=>{
    setLoader('running');
    const payload = {token:token}
    try {
      const res = await fetchApi(GetUserDetailsByToken, "POST", payload);
      if(res.status === 'success'){
        const{fname,lname, user_email, company_name,user_type,is_user_register}= res.data[0];
        setState((prevState) => ({
          ...prevState, 
          firstName: fname,
          lastName:lname,
          email:user_email,
          companyName:company_name,
          userType:user_type
        }));
        if(is_user_register){
          toast.error('This email is already registered. Log in to continue your journey.')
          window.setTimeout(() => {
            history.push('/user');
          }, 2000); // Delay for 2 seconds (or adjust as needed)
        }else{
          setLoader(null);
        }
        
        
      }else{
        toast.error(t(res?.data?.message));
        setLoader(null);
      }
    } catch (error) {
      window.console.error(error);
      setLoader(null);
    }
  }

  const verifyEmailDetails = async()=>{

    const payload = {email: state.email};
    setLoader('verify-email');

    try {
      const res = await fetchApi(VerifyUserEmail,"POST", payload);
      if(res.status === "success"){
        
        const{fname,lname, user_email, company_name,is_verified,user_type}= res.data;
        if(is_verified){
          setState((prevState) => ({
            ...prevState, 
            firstName: fname,
            lastName:lname,
            email:user_email,
            companyName:company_name,
            userType:user_type
          }));
          setIsEmailVerified(is_verified);
          setRegstrationWithCompany(false);
        }else{
          setIsEmailVerified(null);
          toast.error(t('Email is not verified'));
          setLoader(null);
        }
        setLoader(null);
        
      }else{
        setIsEmailVerified(null);
        toast.error(t(res?.data?.message));
        setLoader(null);
      }
    } catch (error) {
      toast.error(t(error))
      setLoader(null);
    }

  }

  const sendOtp = async()=>{
    setLoader('send-otp');
    const payload = {email: state.email}

    try {
      const res = await fetchApi(SendRegistrationOtp,"POST", payload);
      if(res.status === "success"){
        toast.success(t(res?.data?.message));
        setScreen("otp-verification-form");
        setToken(res?.data?.token);
        // setResendbutton(true);
        setSecondsLeft(180);
        setSecondsLeft(180);
        setResend(true);
        setLoader(null);
        setRegstrationWithCompany(false);
      }else{
        // setIsEmailVerified(false);
        toast.error(t(res?.data?.message));
        setLoader(null);
      }
    } catch (error) {
      toast.error(t(error));
      setLoader(null);
    }

  }

  const sendOtpWithCompany = async()=>{
    setLoader('send-otp');
    const payload = {mail: state.email,company_id:state.companyId,fname:state.firstName,lname:state.lastName}

    try {
      const res = await fetchApi(SendRegistrationOtpWithCompany,"POST", payload);
      if(res.status === "success"){
        toast.success(t(res?.data?.message));
        setScreen("otp-verification-form");
        setToken(res?.data?.token);
        // setResendbutton(true);
        setSecondsLeft(180);
        setSecondsLeft(180);
        setResend(true);
        setLoader(null);
      }else{
        // setIsEmailVerified(false);
        toast.error(t(res?.data?.message));
        setLoader(null);
      }
    } catch (error) {
      toast.error(t(error));
      setLoader(null);
    }

  }

  const FetchWellnessInterests = async(language)=>{
    try {
      const res = await fetchApi(GetWellnessInterests + "/" + language, "GET");
      if(res.status === 'success'){
        setWellnessInterests(res.data?.[0])
      }else{
        toast.error(t(res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }


  const getAllWellbeingPillars = async (language) => {
    setLoader('running');
    try {
      const res = await fetchApi(GetWellbeingPillars + "/" + language, "GET");

      if (res.status === "success") {
        setWellbeingPillars(res.data);
        setLoader(null);
      } else {
        toast.error(t(res.data.message || "Something went wrong"));
        setLoader(null);

      }
    } catch (error) {
      window.console.error(error);
      setLoader(null);
    }
  }; 

 
  const SelectProduct = (selectedId) => {
    setSelectedInterests((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.id === selectedId);
  
      if (isAlreadySelected) {
        // Remove it
        return prevSelected.filter((item) => item.id !== selectedId);
      } else {
        // Find the interest object from wellnessInterests by id
        const interestToAdd = wellnessInterests.find((item) => item.id === selectedId);
        if (interestToAdd) {
          return [...prevSelected, interestToAdd];
        }
        return prevSelected; // Fallback if not found
      }
    });
  };

  const SelectGoal = (id) => {
    setSelectedWellbeingPillars((prevGoals) => {
      const alreadySelected = prevGoals.includes(id);
  
      if (alreadySelected) {
        // Remove if already selected
        return prevGoals.filter((goalId) => goalId !== id);
      } else if (prevGoals.length < 3) {
        // Add only if less than 3 are selected
        return [...prevGoals, id];
      } else {
        // Do nothing if 3 already selected
        return prevGoals;
      }
    });
  };
  
  const onChangeInput = (e) => {

    setState((prevState) => ({
      ...prevState,  // Spread the previous state
      [e.target.name]: e.target.value // Update only the field that changed
    }));
    if((e.target.name === 'cpassword' ) ){
      if(e.target.value != state?.password){
        setPasswordError(true);
      }else{
        setPasswordError(false);
      }
    }
    if((e.target.name === 'password') ){
      if(e.target.value != state?.cpassword){
        setPasswordError(true);
      }else{
        setPasswordError(false);
      }
    }
    if(e.target.name === 'contactNumber'){
      isValidContactNumber(e.target.value) ? setContactError(false) : setContactError(true);
    }

    if(e.target.name === 'email'){
      isEmailValid(e.target.value) ? setEmailError(false) : setEmailError(true);
    }
  }

  const formatTime = (totalSeconds) => {
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${minutes} : ${seconds}`;
  };


  //All the API calls



  const verifyOtpDetails = async () => {
    setLoader('verify-otp');
    const payload = {
      otp: parseInt(otp,10),
      token: token,
      work_email: state.email,
    };

    try {
      const res = await fetchApi(VerifyRegistrationOtp, "POST", payload);
      if (res.status === "success") {
        toast.success(t(res?.data?.[0]));
        setScreen("complete-profile");
        setOtpError(false);
        setLoader(null);
      } else {
        // toast.error(res?.data?.message || "Something went wrong");
        setOtpError(true);
        setLoader(null);
      }
    } catch (error) {
      window.console.error(error);
      setLoader(null);
    }
  };


  const resendOtp = async () => {
    setResendbutton(false);
    const payload = {
      token: registrationToken,
      work_email: state.email,
    };

    const apiUrl = `${ResendOtpForComapny}`;

    try {
      const res = await fetchApi(apiUrl, "POST", payload);

      if (res.status === "success") {
        toast.success(t(res?.data?.message));
        setResendbutton(true);
        setSecondsLeft(180);
        // setScreen("otp");
      } else {
        toast.error(t(res.data.message || "Something went wrong"));

      }
    } catch (error) {
      window.console.error(error);
    }
  };


  const registerUser = async () => {
    const payload = {
      fname:state.firstName,
      lname:state.lastName,
      password:state.password,
      token:token,
      time_zone:TimeZone,
      work_email: state.email,
      areas_of_interest:selectedInterests?.map((item) => item?.id),
      wellbeing_pillars:selectedWellbeingPillars,
      accepted_privacy_policy:state.privacyPolicy,
      birthday:dayjs(state.birthDate).format('YYYY-MM-DD'),
      phone_number:state.contactNumber,
      user_type:state.user_type,
      email:state.email,
      is_health_coach:0
    };
    setLoader('running');

    try {
      const res = await fetchApi(RegisterUser, "POST", payload);

      if (res.status === "success") {
        // toast.success(res.data.message);
        localStorage.setItem('new_user', 'true');
        localStorage.setItem('AUTH_TOKEN', res?.data?.checksum);

        // i18n.changeLanguage('en');
        // localStorage.setItem("lang", 'en');

        setAuthenticatedUser();
        history.push('/portal');
        setLoader(null);
      } else {
        toast.error(t(res?.data?.message || "Something went wrong"));
        setLoader(null);

      }
    } catch (error) {
      setLoader(null);
    }
  };


  const handleDropDown = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const onChangeDate = (e, /*statename*/)=>{
    setState((prevState) => ({
      ...prevState,  // Spread the previous state
      birthDate: dayjs(e) // Update only the field that changed
    }));

    setDatePopup(false)


  }

  const verifyCompanyDetails = async () => {
    setLoader('verify-company');
    const payload = {
      company_name: companyName,
      password: companyPassword,
    };

    try {
      const res = await fetchApi(VerifyCompanyName, "POST", payload);
      if (res.status === "success") {
        toast.success(t('Company verified successfully'));
        setState((prevState) => ({
          ...prevState, 
          companyName:res?.data?.[0]?.company_name,
          companyId:res?.data?.[0]?.id
        }));
        setRegstrationWithCompany(true);
        setScreen("register-with-company");
        setLoader(null);
      } else {
        toast.error(t(res?.data?.message));
        setLoader(null);
      }
    } catch (error) {
      window.console.error(error);
      setLoader(null);
    }
  };

 

  const LoginCredentials = () =>(
     
    <div className="content">
      <LoginCard>
        <div className="formHeading">{t('Registration')}</div> 
        <RegistrationForm>
          <FieldTitleNew marginBottom={"12px"}>{t('First name')}</FieldTitleNew>
          <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter first name')} name='firstName' 
            value={state.firstName}  onChange={onChangeInput}/>
          <FieldTitleNew marginBottom={"12px"}>{t('Last name')}</FieldTitleNew>
          <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter last name')} name='lastName' 
            value={state.lastName}  onChange={onChangeInput}/> 
          <FieldTitleNew marginBottom={"12px"}>{t('Work email')}</FieldTitleNew>
          <InputWrapper>
            <StyledInput maxLength={62} isBorder={emailError} type="email" placeholder={t('Enter work email')} name='email' 
              value={state.email}  onChange={onChangeInput}  disabled={isFromMagicLink}/>
          </InputWrapper>
          {emailError && (
            <ErrorText marginBottom>
              {t('Invalid Email Address')}
            </ErrorText>
          )}
          <FieldTitleNew marginBottom={"12px"} marginTop='12px'>{t('Company name')}</FieldTitleNew>
          <StyledInput  maxLength={100}  marginBottom type="text" placeholder={t('Enter company name')} name='companyName' 
            value={state.companyName}  onChange={onChangeInput} disabled={isFromMagicLink}/>
          <Divider isMargin={"20px 0px"}/>
          <Button disabled={!state.firstName || !state.lastName || !isEmailValid(state.email) || !state?.companyName } onClick={() => {
            setScreen("complete-profile");
          }}> {t('Next')}</Button>

        </RegistrationForm>
      </LoginCard>
    </div>
  )

  const VerifyEmail = () =>(
     
    <div className="content">
      <LoginCard>
        <div className="formHeading">{t('Registration')}</div> 
        <RegistrationForm>
          <FieldTitleNew marginBottom={"12px"}>{t('Work email')}</FieldTitleNew>
          <InputWrapper>
            <StyledInput maxLength={62} isBorder={emailError} type="email" placeholder={t('Enter work email')} name='email' 
              value={state.email}  onChange={onChangeInput}  disabled={isFromMagicLink || isEmailVerified}/>
            {state.email && !emailError && <EyeIconWrapper onClick={()=>(!isEmailVerified && !loader)&& verifyEmailDetails()} disabled={isEmailVerified}>
              {loader === 'verify-email' ? <Spinner width={"22px"} height={"22px"} color={'#F37A65'}/> :<span className='text'>{ isEmailVerified ? t("Verified") : t('Verify') }</span>}
            </EyeIconWrapper>}
          </InputWrapper>
          {emailError && (
            <ErrorText marginBottom>
              {t('Invalid Email Address')}
            </ErrorText>
          )}
          {isEmailVerified && (<>

            <FieldTitleNew marginBottom={"12px"} marginTop='12px'>{t('First name')}</FieldTitleNew>
            <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter first name')} name='firstName' 
              value={state.firstName}  onChange={onChangeInput}/>
            <FieldTitleNew marginBottom={"12px"}>{t('Last name')}</FieldTitleNew>
            <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter last name')} name='lastName' 
              value={state.lastName}  onChange={onChangeInput}/> 
            
            <FieldTitleNew marginBottom={"12px"}>{t('Company name')}</FieldTitleNew>
            <StyledInput  maxLength={100}  marginBottom type="text" placeholder={t('Enter company name')} name='companyName' 
              value={state.companyName}  onChange={onChangeInput} disabled={true}/>
          </>)}


          <Divider isMargin={"0px 0px 20px 0px"}/>
          <ButtonContainer>
            {!isEmailVerified && <BorderButton isButtonWidth="auto" autoMargin onClick={() =>{setScreen("company-verifcation")}}>
              <div className="arrowTextContainer">{t("Register with company name")}</div>
            </BorderButton>}
            <Button autoMargin disabled={!state.firstName || !state.lastName || !isEmailValid(state.email) || !state?.companyName || loader === 'send-otp' } onClick={() => {
              sendOtp();
            }}> {loader === 'send-otp'? <Spinner width={'22px'} height={'22px'} color={'#F37A65'}/> : t('Next')}</Button>
          </ButtonContainer>

        </RegistrationForm>
      </LoginCard>
    </div>
  )

  const togglePasswordVisibility = (type) => {

    type === 'password' ? setShowPassword((prev) => !prev) : type === 'companyPassword' ? setShowCompanyPassword((prev) => !prev) : setShowCPassword((prev) => !prev);
  };

  const VerifyCompany = () =>(
     
    <div className="content">
      <LoginCard>
        <div className="formHeading">{t('Registration')}</div> 
        <RegistrationForm>
          <FieldTitleNew marginBottom={"12px"} marginTop='12px'>{t('Company name')}</FieldTitleNew>
          <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter company name')} name='firstName' value={companyName}  onChange={(e)=>setCompanyName(e.target.value)}/>
          <FieldTitleNew marginBottom={"12px"} marginTop='12px'>{t('Company Password')}</FieldTitleNew>
          <InputWrapper>
            <StyledInput
              maxLength={"50"}
              type={showCompanyPassword ? 'text' : 'password'}
              placeholder={t("Enter company password")}
              name="password"
              value={companyPassword}
              onChange={(e)=>setCompanyPassword(e.target.value)}
              minLength={'8'}
            />
            <EyeIconWrapper onClick={()=>togglePasswordVisibility('companyPassword')}>
              <span>{ showCompanyPassword ? hidePassword() : PasswordEyeIcon() }</span>
            </EyeIconWrapper>
          </InputWrapper>
          {companyPassword && companyPassword.length < 8 && (
            <ErrorText>{t('The password must be at least 8 characters.')}</ErrorText>
          )}


          <Divider isMargin={"0px 0px 20px 0px"}/>
          <ButtonContainer>
            <BorderButton isButtonWidth="auto" autoMargin onClick={() =>{setScreen("verify-email");}}>
              <div className="arrowTextContainer">{t("Register with email")}</div>
            </BorderButton>
            <Button autoMargin disabled={ !companyName || companyPassword.length < 8 || !companyPassword || loader === 'verify-company' } onClick={() => {
              verifyCompanyDetails();
            }}> {loader === 'verify-company'? <Spinner width={'22px'} height={'22px'} color={'#F37A65'}/> : t('Next')}</Button>
          </ButtonContainer>

        </RegistrationForm>
      </LoginCard>
    </div>
  )

  const RegisterWithCompany = () =>(
     
    <div className="content">
      <LoginCard>
        <div className="formHeading">{t('Registration')}</div> 
        <RegistrationForm>
          <FieldTitleNew marginBottom={"12px"}>{t('Work email')}</FieldTitleNew>
          <InputWrapper>
            <StyledInput maxLength={62} isBorder={emailError} type="email" placeholder={t('Enter work email')} name='email' 
              value={state.email}  onChange={onChangeInput}  />
          </InputWrapper>
          {emailError && (
            <ErrorText marginBottom>
              {t('Invalid Email Address')}
            </ErrorText>
          )}

          <FieldTitleNew marginBottom={"12px"} marginTop='12px'>{t('First name')}</FieldTitleNew>
          <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter first name')} name='firstName' 
            value={state.firstName}  onChange={onChangeInput}/>
          <FieldTitleNew marginBottom={"12px"}>{t('Last name')}</FieldTitleNew>
          <StyledInput  maxLength={50}  marginBottom type="text" placeholder={t('Enter last name')} name='lastName' 
            value={state.lastName}  onChange={onChangeInput}/> 
          
          <FieldTitleNew marginBottom={"12px"}>{t('Company name')}</FieldTitleNew>
          <StyledInput  maxLength={100}  marginBottom type="text" placeholder={t('Enter company name')} name='companyName' 
            value={state.companyName}  onChange={onChangeInput} disabled={true}/>


          <Divider isMargin={"0px 0px 20px 0px"}/>
          <ButtonContainer>
            <Button autoMargin disabled={!state.firstName || !state.lastName || !isEmailValid(state.email) || !state?.companyName || loader === 'send-otp' } onClick={() => {
              sendOtpWithCompany();
            }}> {loader === 'send-otp'? <Spinner width={'22px'} height={'22px'} color={'#F37A65'}/> : t('Verify Email')}</Button>
          </ButtonContainer>

        </RegistrationForm>
      </LoginCard>
    </div>
  )



  const CompleteProfile = () =>
  
    (
     
      <div className="content">
        <LoginCard>
          <div className="formHeading">{t('Login Credentials')}</div> 
          <RegistrationForm>

            <FieldTitleNew marginBottom={"12px"}>{t('Password')}</FieldTitleNew>

            {/* <StyledInput  maxLength={100}  marginBottom type="password" placeholder={t('Enter password')} name='password' 
              value={state.password}  onChange={onChangeInput}/> */}
            <InputWrapper>
              <StyledInput
                maxLength={"50"}
                type={showPassword ? 'text' : 'password'}
                placeholder={t("Enter password")}
                name="password"
                value={state.password}
                onChange={onChangeInput}
                minLength={'8'}
              />
              <EyeIconWrapper onClick={()=>togglePasswordVisibility('password')}>
                <span>{ showPassword ? hidePassword() : PasswordEyeIcon() }</span>
              </EyeIconWrapper>
            </InputWrapper>
            {state.password && state.password.length < 8 && (
              <ErrorText>{t('The password must be at least 8 characters.')}</ErrorText>
            )}

            <FieldTitleNew marginBottom={"12px"} marginTop={'12px'}>{t('Confirm password')}</FieldTitleNew>
            {/* <StyledInput  maxLength={100} isBorder={passwordError}  type="password" placeholder={t('Enter confirm password')} name='cpassword' 
              value={state.cpassword}  onChange={onChangeInput}/>  */}

            <InputWrapper>
              <StyledInput
                maxLength={"50"}
                type={showCPassword ? 'text' : 'password'}
                placeholder={t("Enter confirm password")}
                name="cpassword"
                value={state.cpassword}
                onChange={onChangeInput}
              />
              <EyeIconWrapper onClick={()=>togglePasswordVisibility('cpassword')}>
                <span>{ showCPassword ? hidePassword() : PasswordEyeIcon() }</span>
              </EyeIconWrapper>
            </InputWrapper>
            {passwordError && state.cpassword && (
              <ErrorText marginBottom>
                {t('Passwords do not match. Please re-enter.')}
              </ErrorText>
            )}

            <DateCalendarWrapper style={{margin:(!passwordError || !state.cpassword) ? "20px 0px" : '0px 0px 20px 0px'}} m>
              <div className="date-title">{t('Birthday')}</div>
              <DateCard onClick={()=> setDatePopup(true)} color={!state?.birthDate ? true : false}>
                {state?.birthDate? dayjs(state?.birthDate).format('MM/DD/YYYY'): t("Select date of birth [MM/DD/YYYY]")}
                {BirthdateCalendarIcon()}
              </DateCard>
            </DateCalendarWrapper> 

            <FieldTitleNew marginBottom={"12px"}>{t('Contact number')}</FieldTitleNew>
            <StyledInput  maxLength={100}  type="number" placeholder={t('Enter contact number')} name='contactNumber' 
              value={state.contactNumber}  onChange={onChangeInput}/>
            {contactError && (
              <ErrorText marginBottom>
                {t('Please enter valid contact number')}
              </ErrorText>
            )}
            <RadioButtonWrapper isMargin={contactError ? '0px' : "12px"} gap>
              <div className="RadioButtonContainer " onClick={() =>{setState((prevState) => ({...prevState,privacyPolicy: !state.privacyPolicy}));}}>
                <RadioButton
                  id="global"
                  handler={() =>{setState((prevState) => ({...prevState,privacyPolicy: !state.privacyPolicy}));}}
                  type="radio"
                  checked={state.privacyPolicy}
                />
                <div className="label">{t("I agree to")} {"Woliba's"}               
                  <a 
                    className="terms" 
                    href="https://woliba.io/terms-of-use" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >{" "}{t('Terms of Service')}</a>{" "}{t('and')} {" "}                
                  
                  <a 
                    className="terms" 
                    href="https://woliba.io/privacy-policy" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >{t('Privacy Policy')}.</a>

                </div> 
              </div>
            </RadioButtonWrapper>
            <Divider isMargin={"20px 0px"}/>

            <ButtonContainer>
              <BorderButton autoMargin onClick={() =>{isFromMagicLink ? setScreen("get-started") : registrationWithCompany ? setScreen("register-with-company") :setScreen("verify-email")}}>
                <div className="arrowTextContainer">{BackArrowFeed("#F37A65")}{t("Back")}</div>
              </BorderButton>
              <Button autoMargin disabled={!state?.password || !state?.cpassword || !state.privacyPolicy || !state?.birthDate || !state.contactNumber || contactError || state.password.length < 8 || passwordError  } onClick={() => {setScreen('wellness-interest');}}> {t('Next')}</Button>
            </ButtonContainer>
  
          </RegistrationForm>
        </LoginCard>
        {datePopup && <CustomCalendar showModal={datePopup} onClose={()=>setDatePopup(false)} changeDate={onChangeDate}/>}
      </div>
    )

  const WellnessInterestForm = () => 
    (
      <div className="content">
        <LoginCard isFontSize={"24px"} isLineHeight={"36px"} isWellnessCard>
          <div className="formHeading">{t('Select all wellness interests that apply - at least one is required.')}</div> 
          <WellnessCardNew>
            {/* <Divider id="divider" isMargin={"20px 0px"}></Divider> */}
            {WellnessData?.map((data,index)=>(
              <InterestCard key={index} >
                <div className="interest-container" onClick={()=>handleDropDown(index)}>
                  <div className="interestType">{index === 7 ? t("Other Sports") : t(data)}</div>
                  <div  style={{   transform: activeIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease"}} className="dropicon"> {DropIcon("#F37A65")}</div>
                </div>
                {activeIndex === index && (
                  <div className="dropdown-wrapper">
                    {wellnessInterests.map((listData, index) => {
                      const isMatchingInterest = selectedInterests?.some((item) => item?.id === listData?.id); // Check if listData?.id exists in interest array
                      if (data.toLowerCase().trim() === (interestData ? listData?.interest_type.toLowerCase().trim() : listData?.goal_type.toLowerCase().trim())) {
                        return (
                          <DropdownContent userInterest={isMatchingInterest} key={index} onClick={()=>SelectProduct(listData?.id)} style={{cursor:'pointer'}}>
                            {interestData && isMatchingInterest  ?  <img src={`${ImageUrl}/${listData?.interest_white_icon}`} className='category-img'/> :  <img src={`${ImageUrl}/${listData?.interest_color_icon}`} className='category-img'/>}
                            <div className="listContent">{t(listData?.name)}</div>
                          </DropdownContent>
                        );
                      }
                    })}
                  </div>
                )}
              </InterestCard>))}
          </WellnessCardNew>
          <ButtonContainer>
            <BorderButton autoMargin onClick={() =>{setScreen("complete-profile")}}>
              <div className="arrowTextContainer">{BackArrowFeed("#F37A65")}{t("Back")}</div>
            </BorderButton>
            <Button disabled={!selectedInterests.length} onClick={() => {setScreen('wellbeing-pillars');}}> {t('Next')}</Button>
          </ButtonContainer>
        </LoginCard>
      </div>

    )

  const WellbeingPillarsForm = () => 
    (
      <div className="content">
        <CheckboxContainer isMaxWidth={"1414px"} isFontSize={"24px"} isLineHeight={"36px"}>
          <div className="heading">{t('Select any 3 well-being pillars goal you want to achieve')}</div>
          <CheckboxGrid>
            
            {wellbeingPillars?.map((pillar, index)=>(
              <PillarCard isCardWidth={"330px"}  key={index + pillar.id}  onClick={()=>SelectGoal(pillar.id)}>
                <CheckBoxContainer selected={selectedWellbeingPillars.includes(pillar.id) ? true : false}>
                  <div className="selection" >{selectedWellbeingPillars.includes(pillar.id)? selectedWellbeingPillars.indexOf(pillar.id) + 1 : null}</div>
                </CheckBoxContainer>
                <div className='text-container'>
                  <div className='productName' title={pillar?.pillar_title}>{pillar?.pillar_title}</div>
                  <div className='desc' title={pillar?.description}>{pillar?.description}</div>
                </div>
              </PillarCard>
            ))}
            
          </CheckboxGrid>
          <Divider isMargin={"20px 0px"}/>
          <BottomCard style={{justifyContent:'center'}} isMarginLeft={'0px'}>
            <div className="centerButton">
              <BorderButton autoMargin onClick={() =>{setScreen("wellness-interest")}}>
                <div className="arrowTextContainer">
                  {BackArrowFeed("#F37A65")}
                  {t("Back")}
                </div>
              </BorderButton>
              <Button isButtonWidth={"200px"} disabled={selectedWellbeingPillars.length < 3} onClick={ selectedWellbeingPillars.length < 3 ? null : registerUser}> {t("Done")}</Button>
            </div>
          </BottomCard>
        </CheckboxContainer>
      </div>

    )


  const otpVerificationForm = () => 
    (
      <div className="content">
        <LoginCard isError={otpError}>
          <div className="formHeading">{t('Input verification code')}</div> 
          <div className="otpText">{t('We’ve sent a 6-digit OTP to your work email Please enter it below to continue.')}</div>
  
          <div className="flex justify-between">
            {Array.from({ length: 6 }).map((_, index) => (
              <input
                key={index}
                type="number"
                className="otp-input"
                value={otp[index] || ""} // Controlled input
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow single digit input
                  if (value.length > 1) {
                    e.target.value = value.slice(0, 1); // Trim to one digit
                  }
                  const otpArray = otp.split(""); // Convert current OTP string to an array
                  otpArray[index] = e.target.value; // Set the value in the correct index
                  setOtp(otpArray.join(""));
                  // Move focus to the next input if the current one is filled
                  if (value && index < 7) {
                    const next = e.target.nextElementSibling;
                    if (next) next.focus();
                  }
                }}
                onKeyDown={(e) => {
                  // Move focus to previous input on backspace if empty
                  if (e.key === "Backspace" && e.target.value === "") {
                    const prev = e.target.previousElementSibling;
                    if (prev) prev.focus();
                  }
                  // Move focus to the next input on arrow right if filled
                  if (e.key === "ArrowRight" && e.target.value) {
                    const next = e.target.nextElementSibling;
                    if (next) next.focus();
                  }
                  // Move focus to the previous input on arrow left if empty
                  if (e.key === "ArrowLeft" && e.target.value === "") {
                    const prev = e.target.previousElementSibling;
                    if (prev) prev.focus();
                  }
                }}
                onFocus={(e) => e.target.select()} // Select the input value on focus
                // disabled={index > 0 && !loginDetails.otp[index - 1]} // Disable next fields if the previous one is not filled
              />
            ))}
          </div>
          {otpError ? <ErrorText style={{margin:"20px 0px 0px 0px"}} ><span className='otp'>{t('Incorrect OTP')}</span></ErrorText>: null}
          {(secondsLeft !== 0 && resendbutton) ? <div className="resendText">
            {t('Resend OTP in')} {formatTime(secondsLeft)}
            {/* Resend OTP in {secondsLeft} second{secondsLeft !== (1 || 0)  ? 's' : ''} */}
          </div> : <div className="resendButton" onClick={resendOtp}>  {t("Resend")}</div>  }
          <Divider isMargin={"20px 0px"}/>
          <ButtonContainer>
            <BorderButton onClick={() =>{registrationWithCompany ? setScreen("register-with-company") : setScreen("verify-email")}}>
              <div className="arrowTextContainer">
                {BackArrowFeed("#F37A65")}
                {t("Back")}
              </div>
            </BorderButton>
            <Button disabled={otp.length!==6 || loader === 'verify-otp' } onClick={() =>{ otp.length!==6 ? null : verifyOtpDetails()}}> {loader === 'verify-otp' ? <Spinner width={'22px'} height={'22px'} color={'#F37A65'}/> :t("Submit")}</Button>
          </ButtonContainer>
        </LoginCard>
      </div>
    )

  const getBackgroundImage = () => {
    if (loader === 'running') return null;
  
    const screenImageMap = {
      otp: 'company_form.png',
      companySizeForm: 'company_people.png',
      getStartedGroup: 'plg_registration.png',
      confirm: 'confirmation.png',
      productFormGroup: 'Product_Goals.png',
    };
  
    const registrationScreens = [
      'get-started',
      'otp-verification-form',
      'complete-profile',
      'verify-email',
      'wellness-interest',
      'wellbeing-pillars',
      'company-verifcation',
      'register-with-company'
    ];
  
    const productScreens = ['productFrom', 'goalFrom'];
  
    if (registrationScreens.includes(screen)) return `${ImageUrl}/plg/${screenImageMap.getStartedGroup}`;
    if (productScreens.includes(screen)) return `${ImageUrl}/plg/${screenImageMap.productFormGroup}`;
  
    return `${ImageUrl}/plg/${screenImageMap[screen] || ''}`;
  };
  
  const getBackgroundSize = () => {
    if (screen === 'otp') return '1820px 450px';
    if (screen === 'companySizeForm') return '1235px 535px';
    if (
      ['get-started', 'otp-verification-form', 'complete-profile', 'verify-email', 'wellness-interest', 'wellbeing-pillars'].includes(screen)
    )
      return '1400px 700px';
    if (screen === 'confirm') return '1270px 800px';
    if (['productFrom', 'goalFrom'].includes(screen)) return '1550px 700px';
  
    return 'cover';
  };

  const getLanguageImage = () => {
    const language = lang;
  
    switch (language) {
    case "en":
      return "English.png";
    case "es":
      return "Spanish.png";
    case "pt":
      return "Portuguese.png";
    default:
      return "French.png";
    }
  };
  
  const getLanguageCode = () => {
    const language = lang;
  
    switch (language) {
    case "en":
      return "EN";
    case "es":
      return "SP";
    case "pt":
      return "PT";
    default:
      return "FR";
    }
  };
  
  
  return (
    <>
      
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
      <PageContainer
        style={{
          backgroundImage: `url(${getBackgroundImage()})`,
          backgroundSize: getBackgroundSize(),
        }}>
        <Container>
          {/* Logo */}
          <div style={{  display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '40px', // match logo position
            position: 'relative' }}>
            <div>
              <img
                src={`${ImageUrl}/images/Logo/woliba-logo.png`}
                alt="Woliba Logo"
                style={{
                  // position: 'absolute',
                  // top: '30px',
                  // left: '40px',
                  width: '146px',
                }}
              />
            </div>
            {getLanguages?.length > 1 && (
              <DropdownWrapper isMargin="0px 0px 0px 20px">
                <Dropdown onSelect={(eventKey) => takeLanguageData(eventKey)} style={{ cursor: "pointer" }}>
                  <Dropdown.Toggle as={CustomToggle}>
                    <CustomToggleWrapper>
                      <IconContainer
                        isPadding="10px 0px 10px 10px"
                        active={history.location.pathname.includes('community')}
                        color={'#F37A65'}
                        style={{ display: 'flex' }}
                      >
                        <StyledImage
                          src={`/public/images/NewHeader/${getLanguageImage()}`}
                          alt="Selected Language"
                        />
                        <div style={{ marginLeft: "4px", color: "#184A61", fontFamily: "lato", fontSize: "16px" }}>
                          {getLanguageCode()}
                        </div>
                      </IconContainer>
                      <span>{DropIcon('#F37A65')}</span>
                    </CustomToggleWrapper>
                  </Dropdown.Toggle>
             
                  <CustomMenuV1 align="end" isRight="0px" isTop="16px">
                    {getLanguages.map((data, index) => (
                      <CustomDropdownItemV1
                        bgColor={'#F37A65'}
                        key={index}
                        eventKey={data.name}
                        style={{ display: 'flex' }}
                      >
                        <img src={`${ImageUrl}/${data.image}`} alt={data.display_name} style={{ marginRight: "8px" }} />
                        <div style={{ textTransform: 'capitalize', display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                          {data.display_name}
                        </div>
                      </CustomDropdownItemV1>
                    ))}
                  </CustomMenuV1>
                </Dropdown>
              </DropdownWrapper>
            )}

           
           
          </div>
          {loader === 'running' ? (<RunningLoader text={screen === 'wellbeing-pillars' && t('Getting your wellness journey ready...')}/>): (<>
         
       
            {screen === "get-started" ? LoginCredentials():screen === "verify-email" ? VerifyEmail(): screen === "company-verifcation" ? VerifyCompany() : screen === 'register-with-company'? RegisterWithCompany() : screen === 'complete-profile' ? CompleteProfile() : screen ==="otp-verification-form" ? otpVerificationForm(): screen ==="wellness-interest" ? WellnessInterestForm(): screen==="wellbeing-pillars" ? WellbeingPillarsForm() :null}
         
            {screen !== "confirm" && <Footer style={{marginTop:'20px'}}> 
              <div className="linkContainer">
                <a 
                  className="termText" 
                  href="https://woliba.io/terms-of-use" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  {t("Terms of Use")}
                </a>
                <a 
                  className="termText" 
                  href="https://woliba.io/contact/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  {t("Contact Us")}
                </a>
              </div> 
              {/* <div className="copyrightText"> © 2025 Training Amigo LLC. All Rights Reserved</div> */}
            </Footer>  }</>)}
        </Container>
      </PageContainer>
    </>
  );
}

Registration.propTypes = {
  history: PropTypes.object.isRequired,
  setAuthenticatedUser:PropTypes.func
}

const mapStateToProps = (state) => ({
  getLanguages: state.companyDashboard.getLanguages,
})

const mapDispatchToProps = (dispatch) => ({
  setAuthenticatedUser: () => dispatch(authenticatedUser()),
  fetchLanguages: () => dispatch(fetchLanguages()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Registration)));
